



















































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { deleteTag, editTag, getNewsTags, getTagData, manageList } from '@/api/content/content-news/news'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import Sortable from 'sortablejs'
import { AppModule } from '@/store/modules/app'
const tableData = [
  {
    id: 44421,
    sort: 1,
    code: 'new_game',
    chinsesName: '新游资讯',
    englishName: 'New Game',
    icon: 'https://github.githubassets.com/images/modules/codespaces/github-vscode-logo-light.svg'
  },
  {
    id: 44421,
    sort: 1,
    code: 'new_game',
    chinsesName: '新游资讯',
    englishName: 'New Game',
    icon: 'https://github.githubassets.com/images/modules/codespaces/github-vscode-logo-light.svg'
  },
  {
    id: 44421,
    sort: 1,
    code: 'new_game',
    chinsesName: '新游资讯',
    englishName: 'New Game',
    icon: 'https://github.githubassets.com/images/modules/codespaces/github-vscode-logo-light.svg'
  }
]

@Component({
  name: ''
})
export default class extends Vue {
  params = {
    name_zh: '',
    name_en: '',
    page: 1,
    pageCount: 20
  }
  tableData:any[] = []
  tableLoading: boolean = false
  totalCount: number = 0
  routeQuery: any = {}
  tableHeight: number = 500
  openWindow: any
  activeId = 0
  currentLang: string[] = ['en-us']
  selectedLang: string[] = ['en-us']
  editRow: any = null

  created() {
    this.getTableData()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }

  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 180 - 120
  }

  async getTableData() {
    this.tableLoading = true
    const res: any = await getTagData()
    let dataList = res.data.dataList || []
    this.tableData = dataList.map((item: any) => {
      return {
        form: item,
        id: item[0].tag_id
      }
    })
    console.log(this.tableData)
    this.tableLoading = false
    // this.totalCount = res.data.pageInfo.totalCount
  }

  handleDelete(row: any) {
    let index: number = this.tableData.indexOf(row)
    if (row.id === 0) {
      this.tableData.splice(index, 1)
    } else {
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = row.id.toString()
          deleteTag({ ids }).then((res: any) => {
            if (res.status.code === 0) {
              this['$message'].success('删除成功')
              this.getTableData()
            }
          })
        })
        .catch(() => {})
    }
  }
  handleSave(row: any) {
    // eslint-disable-next-line
    let params = row.form.map(({ id, lang, cid, name, is_default }: any) => ({ id, lang, cid, name, is_default }))
    let en = params[0]
    if (en && en.name.length <= 0) {
      return this.$message.warning('英文名称不能为空')
    }
    editTag(params).then(() => {
      this.currentLang = ['en-us']
      this.activeId = -1
      this.getTableData()
    })
  }
  handleEdit(row: any) {
    this.activeId = +row.id || 0
    this.editRow = JSON.parse(JSON.stringify(row))
  }
  handleAdd() {
    let newly = this.tableData.filter(item => item.id === 0)
    if (newly.length > 0) return false
    let langs = this.currentLang
    let form = langs.map((lang: string, index: number) => ({
      id: 0,
      is_default: lang === 'en-us' ? 1 : -1,
      lang,
      name: '',
      cid: 0,
      newly: true
    }))
    this.tableData.unshift({ form, id: 0 })
  }
  handleSelectAll() {
    let selectedData = this.tableData.filter(item => item.checked)
    if (selectedData.length < this.tableData.length) {
      this.tableData.forEach(item => {
        if (!item.checked) {
          this.$set(item, 'checked', true)
        }
      })
    } else {
      this.tableData.forEach(item => {
        this.$set(item, 'checked', false)
      })
    }
  }
  handleSelectReverse() {
    this.tableData.forEach(item => {
      this.$set(item, 'checked', !item.checked)
    })
  }

  handleLanguageChange(val: string[]) {
    if (val.length === 0) {
      this.currentLang = ['en-us']
    }
    if (this.tableData[0] && this.tableData[0].id === 0) {
      let formMap = new Map(this.tableData[0]['form'].map((item: any) => [item.lang, item]))
      let form = this.currentLang.map((lang: string) => formMap.get(lang) || ({
        id: 0,
        is_default: lang === 'en-us' ? 1 : -1,
        lang,
        name: '',
        cid: 0
      }))
      this.$set(this.tableData[0], 'form', form)
    }
  }

  handleSwitchLanguage(lang: string) {
    if (lang === 'en-us') return false
    let index = this.currentLang.indexOf(lang)
    if (index < 0) {
      this.currentLang.push(lang)
    } else {
      this.currentLang.splice(index, 1)
    }
    if (this.tableData[0] && this.tableData[0].id === 0) {
      let formMap = new Map(this.tableData[0]['form'].map((item: any) => [item.lang, item]))
      let form = this.currentLang.map((lang: string) => formMap.get(lang) || ({
        id: 0,
        is_default: lang === 'en-us' ? 1 : -1,
        lang,
        name: '',
        cid: 0
      }))
      this.$set(this.tableData[0], 'form', form)
    }
  }

  handleClose(row: any) {
    if (row.id === 0) {
      this.handleDelete(row)
    } else {
      this.activeId = 0
      let index = this.tableData.findIndex(item => item === row)
      this.editRow && (this.tableData[index] = this.editRow)
    }
  }

  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    console.log(table)
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
          }
        }
      })
    }
  }

  get langList() {
    return AppModule.languageList
  }

  get langMap() {
    let map: string[][] = AppModule.languageList.map((item: any) => [item.code, item.name])
    return new Map(map as any[])
  }

  get selectedList() {
    return this.langList.filter(item => this.currentLang.includes(item.code))
  }

  get isShow() {
    return this.tableData.findIndex(item => item.id === 0) >= 0
  }

  @Watch('isShow')
  onShowChange(val: boolean) {
    this.setTableHeight()
  }
}
